import { useState } from 'react';

import { useHovered } from '@/hooks';
import { isApple, titleCase } from '@/utils';

import PlatformIcon from './PlatformIcon';

const OAuthForm = ({
  role,
  login,
  logout,
  accounts,
  disabled,
  platform,
  userName,
  accountId,
  isSignedIn,
  isSigningIn,
  isSigningOut,
  switchAccount,
}) => {
  const [btnEl, setBtnEl] = useState(null);

  const hovered = useHovered(btnEl);

  const isLoading = isSigningIn || isSigningOut;

  const baseTheme = isSignedIn ? 'dark' : 'primary';

  const iconProps = {
    platform,
    className: 'me-2',
    variant: hovered ? 'light' : baseTheme,
  };

  const btnStyle = {
    justifyContent: 'center',
    width: isLoading ? '159px' : '144px',
  };

  const btnClassName = 'btn d-inline-flex align-items-center';

  return (
    <fieldset className="d-flex flex-wrap justify-content-center align-items-center">
      {role && (
        <label
          className={`text-muted me-2`}
          style={role === 'target' ? { width: '3.1915rem' } : {}}
        >
          {titleCase(role)}
        </label>
      )}

      {isSignedIn ? (
        <>
          <button
            type="button"
            ref={setBtnEl}
            style={btnStyle}
            onClick={logout}
            disabled={disabled}
            aria-busy={isSigningOut || undefined}
            className={`${btnClassName} btn-outline-dark`}
          >
            <PlatformIcon {...iconProps} />
            <span className="lh-1" aria-live="polite">
              {isSigningOut ? 'Disconnecting...' : 'Disconnect'}
            </span>
          </button>

          <div className={`ms-2 ${disabled ? 'text-muted' : ''}`}>
            {accounts.length > 0 && !isApple(platform) ? (
              <div className="dropdown d-inline">
                <span
                  role="button"
                  aria-disabled={disabled}
                  data-bs-toggle={disabled ? undefined : 'dropdown'}
                  className={`dropdown-toggle ${disabled ? 'pe-none' : 'cursor-pointer'}`}
                >
                  {isSignedIn ? userName : 'Select account...'}
                </span>

                <ul className="dropdown-menu shadow">
                  {accounts.map((account) => (
                    <li key={account.accountId}>
                      <button
                        disabled={disabled}
                        onClick={() => switchAccount(account)}
                        className={`dropdown-item dropdown-item-accent ${
                          account.accountId === accountId ? 'active' : ''
                        }`}
                      >
                        {account.userName}
                      </button>
                    </li>
                  ))}

                  <li>
                    <hr className="dropdown-divider" />
                  </li>

                  <li>
                    <button
                      onClick={login}
                      disabled={disabled}
                      className="dropdown-item dropdown-item-accent"
                    >
                      + Connect New
                    </button>
                  </li>
                </ul>
              </div>
            ) : (
              isSignedIn && <span>{userName}</span>
            )}
          </div>
        </>
      ) : (
        <button
          type="button"
          ref={setBtnEl}
          onClick={login}
          style={btnStyle}
          disabled={disabled || isSigningIn}
          aria-busy={isSigningIn || undefined}
          className={`${btnClassName} btn-outline-custom btn-outline-${platform}`}
        >
          <PlatformIcon {...iconProps} />
          <span
            aria-live="polite"
            className={`lh-1 ${disabled ? 'text-muted' : ''}`}
          >
            {isSigningIn ? 'Connecting...' : 'Connect'}
          </span>
        </button>
      )}
    </fieldset>
  );
};

export default OAuthForm;
